import { UploadBadgeField } from './UploadBadgeField'
import { withUploadBadgeField } from './withUploadBadgeField'

const ConnectedUploadBadgeField = withUploadBadgeField(UploadBadgeField)

export { ConnectedUploadBadgeField as UploadBadgeField }
